import { captureException } from '@contra/sentry/react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseJson = (json: string): any => {
  try {
    // eslint-disable-next-line no-restricted-properties
    return JSON.parse(json);
  } catch (error) {
    captureException(error, {
      extra: {
        json,
      },
    });

    throw error;
  }
};
